import { handleActions, handleAction } from "redux-actions";
import {
  AUTH,
  SET_PROFILE,
  SET_CURRENT_ROUTE,
  LOGOUT,
  SHOW_NOTIFICATION,
  CLOSE_NOTIFICATION,
  SET_SIDE_MENU_STATE,
  OPEN_ALERT_FORM,
  CLOSE_ALERT_FORM,
  EDIT_SELECTED_ALERT,
  ALERT_FORM_TOOGLE_LOADING,
  SET_ALERT_LIST,
  ADD_NEW_ALERT,
  UPDATE_ALERT,
  DELETE_ALERT,
  THEME,
  OPEN_MACHINE_FORM,
  CLOSE_MACHINE_FORM,
  EDIT_SELECTED_MACHINE,
  MACHINE_FORM_TOOGLE_LOADING,
  UPDATE_MACHINE_FORM_DATA,
  OPEN_CALIBRATION_FORM,
  CLOSE_CALIBRATION_FORM,
  CALIBRATION_FORM_TOGGLE_LOADING,
  ADD_CALIBRATION_TO_MACHINE,
  UPDATE_MACHINE_CALIBRATIONS,
  OPEN_PROGRAMS_FORM,
  CLOSE_PROGRAMS_FORM,
  PROGRAMS_FORM_TOGGLE_LOADING,
  UPDATE_MACHINE_PROGRAMS,
  OPEN_DOSIFICATIONS_FORM,
  CLOSE_DOSIFICATIONS_FORM,
  DOSIFICATIONS_FORM_TOGGLE_LOADING,
  UPDATE_MACHINE_DOSIFICATIONS,
  SELECT_PROGRAM_FOR_DOSIFICATION,
  SELECT_WASHER_FOR_DOSIFICATION,
} from "./../../constants";
import { createCrudReducers } from "../../utils/crudGenerator";

/* BASIC */
export const authorization = handleActions(
  {
    [AUTH]: (state, action) => action.payload,
    [LOGOUT]: () => ({ auth: false }),
  },
  null
);

/* PROFILE */
export const profile = handleActions(
  {
    [SET_PROFILE]: (state, action) => action.payload,
  },
  null
);

/* APP */
export const currentRoute = handleAction(
  SET_CURRENT_ROUTE,
  (state, action) => {
    const r = action.payload || {};
    const { icon, action: routeAction, ...serializable } = r;
    return serializable;
  },
  {}
);

export const notifications = handleActions(
  {
    [SHOW_NOTIFICATION]: (state, action) => action.payload,
    [CLOSE_NOTIFICATION]: (state, action) => ({
      show: false,
      status: null,
      message: null,
    }),
  },
  { show: false, status: null, message: null }
);

/* APP */
export const app = handleActions(
  {
    [SET_SIDE_MENU_STATE]: (state, action) => {
      return { ...state, isCollapsedSideMenu: action.payload };
    },
  },
  { isCollapsedSideMenu: true }
);

export const currentTheme = handleAction(
  THEME,
  (state, action) => action.payload,
  false
);

export const alerts = handleActions(
  {
    [SET_ALERT_LIST]: (state, action) => action.payload,
    [ADD_NEW_ALERT]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [UPDATE_ALERT]: (state, action) => {
      const newState = {
        ...state,
        [action.payload.value]: action.payload,
      };
      return newState;
    },
    [DELETE_ALERT]: (state, action) => {
      action.payload.forEach((number) => {
        delete state[number];
      });
      return { ...state };
    },
  },
  null
);

export const alertsForm = handleActions(
  {
    [OPEN_ALERT_FORM]: (state) => ({
      show: !state.show,
      data: null,
      loading: false,
    }),
    [CLOSE_ALERT_FORM]: () => ({ show: false, data: null, loading: false }),
    [EDIT_SELECTED_ALERT]: (s, action) => ({
      show: true,
      data: action.payload,
      loading: false,
    }),
    [ALERT_FORM_TOOGLE_LOADING]: (state) => ({
      ...state,
      loading: !state.loading,
    }),
  },
  { show: false, data: null, loading: false }
);

export const calibrationForm = handleActions(
  {
    [OPEN_CALIBRATION_FORM]: (state) => ({
      show: true,
      data: null,
      loading: false,
    }),
    [CLOSE_CALIBRATION_FORM]: () => ({
      show: false,
      data: null,
      loading: false,
    }),
    [CALIBRATION_FORM_TOGGLE_LOADING]: (state) => ({
      ...state,
      loading: !state.loading,
    }),
  },
  { show: false, data: null, loading: false }
);

export const programsForm = handleActions(
  {
    [OPEN_PROGRAMS_FORM]: (state) => ({
      show: true,
      data: null,
      loading: false,
    }),
    [CLOSE_PROGRAMS_FORM]: () => ({
      show: false,
      data: null,
      loading: false,
    }),
    [PROGRAMS_FORM_TOGGLE_LOADING]: (state) => ({
      ...state,
      loading: !state.loading,
    }),
  },
  { show: false, data: null, loading: false }
);

export const dosificationsForm = handleActions(
  {
    [OPEN_DOSIFICATIONS_FORM]: (state) => ({
      ...state,
      show: true,
      data: null,
      loading: false,
    }),
    [CLOSE_DOSIFICATIONS_FORM]: (state) => ({
      ...state,
      show: false,
      data: null,
      loading: false,
    }),
    [DOSIFICATIONS_FORM_TOGGLE_LOADING]: (state) => ({
      ...state,
      loading: !state.loading,
    }),
    [SELECT_PROGRAM_FOR_DOSIFICATION]: (state, action) => ({
      ...state,
      selectedProgram: action.payload,
    }),
    [SELECT_WASHER_FOR_DOSIFICATION]: (state, action) => ({
      ...state,
      selectedWasherIndex: action.payload,
    }),
  },
  {
    show: false,
    data: null,
    loading: false,
    selectedProgram: null,
    selectedWasherIndex: null,
  }
);

// Función auxiliar para resetear el estado de dosificationsForm
export const resetDosificationsForm = () => ({
  show: false,
  data: null,
  loading: false,
  selectedProgram: null,
});

const userReducers = createCrudReducers("USER");

export const users = userReducers.list;
export const usersForm = userReducers.form;

const customerReducers = createCrudReducers("CUSTOMER");

export const customers = customerReducers.list;
export const customersForm = customerReducers.form;
const laundryReducers = createCrudReducers("LAUNDRY");

export const laundrys = laundryReducers.list;
export const laundrysForm = laundryReducers.form;
const machineReducers = createCrudReducers("MACHINE");

// Custom machinesForm reducer to handle calibrations
export const machinesForm = handleActions(
  {
    [OPEN_MACHINE_FORM]: (state) => ({
      show: true,
      data: {
        programs: [], // Inicializar con array vacío para nuevas máquinas
        dosifications: [], // Inicializar con array vacío para nuevas máquinas
      },
      loading: false,
    }),
    [CLOSE_MACHINE_FORM]: () => ({
      show: false,
      data: {
        programs: [], // Resetear con array vacío
        dosifications: [], // Resetear con array vacío
      },
      loading: false,
    }),
    [EDIT_SELECTED_MACHINE]: (state, action) => ({
      show: true,
      data: {
        ...action.payload,
        programs: action.payload.programs || [], // Asegurar que programs esté presente
        dosifications: action.payload.dosifications || [], // Asegurar que dosifications esté presente
      },
      loading: false,
    }),
    [MACHINE_FORM_TOOGLE_LOADING]: (state) => ({
      ...state,
      loading: !state.loading,
    }),
    [UPDATE_MACHINE_FORM_DATA]: (state, action) => ({
      ...state,
      data: action.payload,
    }),
    [ADD_CALIBRATION_TO_MACHINE]: (state, action) => {
      const currentCalibrations = state.data?.calibrations || [];
      const updatedData = {
        ...state.data,
        calibrations: [...currentCalibrations, action.payload],
      };
      return {
        ...state,
        data: updatedData,
      };
    },
    [UPDATE_MACHINE_CALIBRATIONS]: (state, action) => {
      const updatedData = {
        ...state.data,
        calibrations: action.payload,
      };
      return {
        ...state,
        data: updatedData,
      };
    },
    [UPDATE_MACHINE_PROGRAMS]: (state, action) => {
      const updatedData = {
        ...state.data,
        programs: action.payload,
      };
      return {
        ...state,
        data: updatedData,
      };
    },
    [UPDATE_MACHINE_DOSIFICATIONS]: (state, action) => {
      const updatedData = {
        ...state.data,
        dosifications: action.payload,
      };
      return {
        ...state,
        data: updatedData,
      };
    },
  },
  { show: false, data: null, loading: false }
);

export const machines = machineReducers.list;
